import {
  fetchWaitlistCoupons,
  createWaitlistCoupon,
  updateWaitlistCoupon,
} from './coupons.service';

export default {
  namespaced: true,
  state: {
    coupons: [],
    subsidies: [],
  },

  mutations: {
    setCoupons(state, coupons) {
      state.coupons = coupons;
    },
    setSubsidies(state, subsidies) {
      state.subsidies = subsidies;
    },
    updateCoupon(state, { id, coupon }) {
      const index = state.coupons.findIndex((c) => c.id === id);
      if (index !== -1) {
        state.coupons.splice(index, 1, coupon);
      }
    },
  },
  actions: {
    async fetchWaitlistCoupons({ dispatch, commit }, providerId) {
      try {
        const data = await fetchWaitlistCoupons(providerId);
        commit('setCoupons', data.coupons);
        commit('setSubsidies', data.subsidies);
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Failed to fetch coupons', error }, { root: true });
      }
    },
    async createWaitlistCoupon({ dispatch, commit, state }, { providerId, couponData }) {
      if (!providerId || !couponData) {
        return;
      }
      try {
        const coupon = await createWaitlistCoupon(providerId, couponData);
        const coupons = [...state.coupons, coupon];
        commit('setCoupons', coupons);
      } catch (error) {
        dispatch('notifications/addToastError', {
          text: `Failed to create coupon ${error.response.data.errors}`,
          error,
        }, { root: true });
      }
    },
    async updateWaitlistCoupon({ dispatch, commit }, { providerId, couponId, couponData }) {
      if (!providerId || !couponId || !couponData) {
        return;
      }
      try {
        const data = await updateWaitlistCoupon(providerId, couponId, couponData);
        commit('updateCoupon', { id: data.id, coupon: data });
      } catch (error) {
        dispatch('notifications/addToastError', {
          text: `Failed to update coupon ${error.response.data.errors}`,
          error,
        }, { root: true });
      }
    },
  },
};
